import {
  CheckOutlined,
  CloseOutlined,
  DownloadOutlined,
  EyeOutlined,
} from "@ant-design/icons";
import { Button, Card, Image, message, Modal } from "antd";
import React, { useState } from "react";
import {
  Pending,
  ReadyForReview,
  Rejected,
  Verified,
} from "../../../components/components/StatusIndicators";
import useAxios from "../../../hooks/useAxios";
import useAuthUserToken from "../../../hooks/useAuthUserToken";
import useGetFile from "../../../hooks/useGetFile";
import RejectModal from "../../Candidate/components/RejectModal";
import { formatDateDDMMYYYY } from "../../../utils/commonFunctions";
import AIRemarks from "../Components/AIRemarks";

const PanCardSection = ({
  candidateDetails,
  panDetails,
  s3Files,
  setLoading,
  getCandidateDetails,
  getAadharAndPanDetails,
  aiRemarks,
  canAcceptReject
}) => {
  const api = useAxios();
  const { userToken } = useAuthUserToken();
  const { getImage } = useGetFile(userToken);

  const [panModal, setPanModal] = useState(false);
  const [viewPanPhoto, setViewPanPhoto] = useState(false);
  const [panImage, setPanImage] = useState("");
  const [panImgReject, setPanImgReject] = useState(false);
  const [panRejectModal, setPanRejectModal] = useState(false);
  const [imgPanRejectReason, setImgPanRejectReason] = useState("");
  const [panRejectReason, setPanRejectReason] = useState("");

  const togglePanReject = () => setPanRejectModal(!panRejectModal);

  const acceptRejectPanImage = async (status, reason) => {
    setLoading(true);
    try {
      await api.put(
        `/candidate/panCardImageStatus/${candidateDetails?._id}`,
        {
          Status: status,
          ...(reason !== null && { panRejection: reason }),
        },
        { tokenType: "user" },
      );
      setImgPanRejectReason("");
      if (!status) {
        setPanImgReject(!panImgReject);
      }
      await getCandidateDetails();
      setLoading(false);
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  const acceptRejectAcknowledgementNumber = async (_id, status) => {
    setLoading(true);
    try {
      await api.put(
        `/candidate/panCardAcknowledgementStatus/${_id}`,
        {
          Status: status,
          rejectionReason: panRejectReason || null,
        },
        { tokenType: "user" },
      );
      getCandidateDetails();
      setPanRejectReason("");
      if (!status) {
        setPanRejectModal(false);
        setPanRejectModal(false);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
      setPanModal(false);
    }
  };

  const acceptRejectPan = async (_id, status) => {
    setLoading(true);
    try {
      await api.put(
        `/candidateDocuments/aadharPanStatus/${_id}`,
        {
          Status: status,
          rejectionReason: panRejectReason || null,
        },
        { tokenType: "user" },
      );
      getAadharAndPanDetails();
      setPanRejectReason("");
      if (!status) {
        setPanRejectModal(false);
        setPanRejectModal(false);
      }
      setPanModal(false);
    } catch (err) {
      console.error(err);
      message.error(err.response.data.error.message);
    } finally {
      setLoading(false);
    }
  };

  const IS_REJECTED_PHOTO =
    candidateDetails?.panStatus !== null &&
    candidateDetails?.panStatus === false &&
    candidateDetails?.panCardImageFilledStatus === false;

  const IS_REJECTED_ACKNOWLEDGEMENT_NUMBER =
    candidateDetails?.acknowledgementStatus !== null &&
    candidateDetails?.acknowledgementStatus === false &&
    candidateDetails?.acknowledgementFilledStatus === false;

  const IS_REJECTED_PAN_NUMBER =
    panDetails?.documentStatus !== null &&
    panDetails?.documentStatus === false &&
    panDetails?.isFilledStatus === false;

  const IS_VERIFIED_PHOTO = candidateDetails?.panStatus;
  const IS_VERIFIED_NUMBER = panDetails?.documentStatus;
  const IS_VERIFIED_ACK_NUMBER = candidateDetails?.acknowledgementStatus;

  const OCR_PAN = (
    candidateDetails?.panCardImage?.[0]?.OCRData?.response?.pan_number || ""
  )?.trim();

  const ENTER_PAN = (candidateDetails?.panCardNo || "")?.trim();

  const IS_EDITED_PAN = OCR_PAN !== ENTER_PAN;

  const OCR_PAN_ACK = (
    candidateDetails?.panCardImage?.[0]?.OCRData?.response
      ?.acknowledgement_number || ""
  )?.trim();

  const ENTER_PAN_ACK = (candidateDetails?.acknowledgementNo || "")?.trim();

  const IS_EDITED_PAN_ACK = OCR_PAN_ACK !== ENTER_PAN_ACK;

  return (
    <>
      <Card
        className="border bg-white col-md-12 mb-2"
        title={`PAN Verification`}
      >
        <div className="d-flex gap-1">
          <div
            style={{
              ...(IS_REJECTED_PHOTO ? { border: "1px solid red" } : {}),
              // ...(IS_VERIFIED_PHOTO ? { border: "1px solid #00AC1A" } : {}),
              position: "relative",
              minWidth: "280px",
            }}
            className="card p-2"
          >
            <div className="d-flex flex-column justify-content-between h-100">
              <div className="flex justify-between">
                <strong>PAN Card Image : </strong>
                {
                  candidateDetails?.panCardImage?.length !== 0 &&
                  <AIRemarks aiRemarks={aiRemarks} docType={candidateDetails?.panNoType === "pan_acknowledgement" ? "Pan_Acknowledgement" : "Pan_Card"}/>
                }
              </div>
              <div className="gap-1 d-flex flex-row justify-content-between">
                <div className="d-flex">
                  {canAcceptReject && (
                    <>
                      <Button
                        disabled={
                          (candidateDetails?.panStatus &&
                            candidateDetails?.isEmpTempIdCreated) ||
                          candidateDetails?.panCardImage?.length === 0
                        }
                        title="accept"
                        shape="circle"
                        type="success"
                        size="small"
                        icon={<CheckOutlined />}
                        style={{ marginRight: "4px" }}
                        onClick={(e) => acceptRejectPanImage(true)}
                      ></Button>
                      <Button
                        disabled={
                          (candidateDetails?.panStatus &&
                            candidateDetails?.isEmpTempIdCreated) ||
                          candidateDetails?.panCardImage?.length === 0
                        }
                        title="reject"
                        shape="circle"
                        type="danger"
                        size="small"
                        icon={<CloseOutlined />}
                        style={{ marginRight: "4px" }}
                        onClick={() => {
                          setPanImgReject(!panImgReject);
                        }}
                      ></Button>
                    </>
                  )}
                  <Button
                    title="view"
                    shape="circle"
                    type=""
                    size="small"
                    disabled={candidateDetails?.panCardImage?.length === 0}
                    icon={<EyeOutlined />}
                    onClick={async () => {
                      const img = await getImage(
                        candidateDetails?.panCardImage[0]?.path,
                      );
                      setPanImage(img);
                      setViewPanPhoto(true);
                    }}
                    style={{ marginRight: "4px" }}
                  ></Button>
                </div>
                <div>
                  {candidateDetails?.panCardImageFilledStatus === false &&
                  candidateDetails?.panStatus === null ? (
                    <Pending />
                  ) : (
                    <>
                      {(candidateDetails?.panStatus === null ||
                        candidateDetails?.panStatus === false) &&
                      candidateDetails?.panCardImageFilledStatus === true ? (
                        <ReadyForReview />
                      ) : (
                        <>
                          {candidateDetails?.panStatus ? (
                            <Verified />
                          ) : (
                            <>
                              <Rejected />
                            </>
                          )}
                        </>
                      )}
                    </>
                  )}
                </div>
              </div>
            </div>
            {IS_REJECTED_PHOTO && (
              <div
                className="d-flex gap-2 text-danger font-weight-bold"
                style={{ position: "absolute", bottom: -20, right: 0 }}
              >
                Reason : {candidateDetails?.panRejection}
              </div>
            )}
          </div>

          <div
            style={{
              ...(IS_REJECTED_PAN_NUMBER || IS_REJECTED_ACKNOWLEDGEMENT_NUMBER
                ? { border: "1px solid red" }
                : {}),
              // ...(IS_VERIFIED_NUMBER || IS_VERIFIED_ACK_NUMBER
              //   ? { border: "1px solid #00AC1A" }
              //   : {}),
              position: "relative",
              flex: "1 1",
            }}
            className="card p-2 d-flex"
          >
            <div className="flex justify-between">
              <div className="flex gap-[5px]">
                <div className="flex flex-row card p-2 gap-[5px]">
                  <strong>Name:</strong>
                  {panDetails?.aadharVerificationDetails?.data?.full_name ? (
                    panDetails?.aadharVerificationDetails?.data?.full_name
                  ) : (
                    <span>Not Filled</span>
                  )}
                </div>
                {candidateDetails?.panNoType === "pan_acknowledgement" ? (
                  <div className="flex flex-row card p-2 gap-[5px]">
                    <strong>Acknowledgement Number:</strong>
                    {candidateDetails?.acknowledgementNo !== "" ? (
                      <>
                        {candidateDetails?.acknowledgementNo}
                        {IS_EDITED_PAN_ACK && (
                          <span
                            style={{
                              fontSize: 12,
                              backgroundColor: "grey",
                            }}
                            className="text-white px-1 rounded"
                          >
                            Edited
                          </span>
                        )}
                      </>
                    ) : (
                      <span>Not Filled</span>
                    )}
                  </div>
                ) : (
                  <div className="flex flex-row card p-2 gap-[5px]">
                    <strong>PAN Number:</strong>
                    {candidateDetails?.panCardNo !== "" ? (
                      <>
                        {candidateDetails?.panCardNo}
                        {IS_EDITED_PAN && (
                          <span
                            style={{
                              fontSize: 12,
                              backgroundColor: "grey",
                            }}
                            className="text-white bg-danger px-1 rounded"
                          >
                            Edited
                          </span>
                        )}
                      </>
                    ) : (
                      <span>Not Filled</span>
                    )}
                  </div>
                )}
              </div>
              {/* <AIRemarks aiRemarks={aiRemarks} /> */}
            </div>
            <div className="d-flex flex-column" style={{ gap: 9 }}>
              <div className="pt-2 d-flex justify-content-between flex-row">
                {candidateDetails?.panNoType === "pan_acknowledgement" ? (
                  <div className="justify-content-center align-items-center">
                    {canAcceptReject && (
                      <>
                        <button
                          className={`btn btn-sm ${
                            candidateDetails?.acknowledgementStatus === undefined ||
                            candidateDetails?.acknowledgementFilledStatus ==
                              false ||
                            candidateDetails?.acknowledgementStatus === true
                              ? "btn-secondary"
                              : "btn-primary"
                          }`}
                          disabled={
                            candidateDetails?.acknowledgementStatus === undefined ||
                            candidateDetails?.acknowledgementStatus === true ||
                            candidateDetails?.acknowledgementFilledStatus == false
                          }
                          onClick={(e) =>
                            acceptRejectAcknowledgementNumber(
                              candidateDetails?._id,
                              true,
                              null,
                            )
                          }
                        >
                          Accept
                        </button>
                        <button
                          className={`btn btn-sm ${
                            candidateDetails?.acknowledgementStatus === undefined ||
                            candidateDetails?.acknowledgementFilledStatus ==
                              false ||
                            candidateDetails?.acknowledgementStatus === true
                              ? "btn-secondary"
                              : "btn-danger"
                          }`}
                          disabled={
                            candidateDetails?.acknowledgementStatus === undefined ||
                            candidateDetails?.acknowledgementStatus === true ||
                            candidateDetails?.acknowledgementFilledStatus == false
                          }
                          onClick={(e) => togglePanReject()}
                        >
                          Reject
                        </button>
                      </>
                    )}
                  </div>
                ) : (
                  <div className="justify-content-center align-items-center">
                    {canAcceptReject && (
                      <>
                        <button
                          className={`btn btn-sm ${
                            panDetails?.documentStatus === undefined ||
                            panDetails?.documentStatus === true
                              ? "btn-secondary"
                              : "btn-primary"
                          }`}
                          disabled={
                            panDetails?.documentStatus === undefined ||
                            panDetails?.documentStatus === true
                          }
                          onClick={(e) =>
                            acceptRejectPan(panDetails._id, true, null)
                          }
                        >
                          Accept
                        </button>
                        <button
                          className={`btn btn-sm ${
                            panDetails?.documentStatus === undefined ||
                            panDetails?.documentStatus === true
                              ? "btn-secondary"
                              : "btn-danger"
                          }`}
                          disabled={
                            panDetails?.documentStatus === undefined ||
                            panDetails?.documentStatus === true
                          }
                          onClick={(e) => togglePanReject()}
                        >
                          Reject
                        </button>
                      </>
                    )}
                  </div>
                )}
                {candidateDetails?.panNoType === "pan_acknowledgement" ? (
                  <div className="d-flex align-items-center">
                    {candidateDetails?.acknowledgementStatus === undefined ||
                    (candidateDetails?.acknowledgementFilledStatus === false &&
                      candidateDetails?.acknowledgementStatus === null) ? (
                      <Pending />
                    ) : (
                      <>
                        {(candidateDetails?.acknowledgementStatus === null ||
                          candidateDetails?.acknowledgementStatus === false) &&
                        candidateDetails.acknowledgementFilledStatus ===
                          true ? (
                          <ReadyForReview />
                        ) : (
                          <>
                            {candidateDetails?.acknowledgementStatus ? (
                              <Verified />
                            ) : (
                              <Rejected />
                            )}
                          </>
                        )}
                      </>
                    )}
                  </div>
                ) : (
                  <div className="d-flex align-items-center">
                    {panDetails?.documentStatus === undefined ||
                    (panDetails?.isFilledStatus === false &&
                      panDetails?.documentStatus === null) ? (
                      <Pending />
                    ) : (
                      <>
                        {(panDetails?.documentStatus === null ||
                          panDetails?.documentStatus === false) &&
                        panDetails.isFilledStatus === true ? (
                          <ReadyForReview />
                        ) : (
                          <>
                            {panDetails?.documentStatus ? (
                              <Verified />
                            ) : (
                              <Rejected />
                            )}
                          </>
                        )}
                      </>
                    )}
                  </div>
                )}
              </div>
            </div>
            {candidateDetails?.panNoType === "pan_number" ? (
              <>
                {IS_REJECTED_PAN_NUMBER && (
                  <div
                    className="d-flex gap-2 text-danger font-weight-bold"
                    style={{ position: "absolute", bottom: -20, right: 0 }}
                  >
                    Reason : {panDetails?.rejectionReason}
                  </div>
                )}
              </>
            ) : (
              <>
                {IS_REJECTED_ACKNOWLEDGEMENT_NUMBER && (
                  <div
                    className="d-flex gap-2 text-danger font-weight-bold"
                    style={{ position: "absolute", bottom: -20, right: 0 }}
                  >
                    Reason : {candidateDetails?.acknowledgementRejection}
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      </Card>

      <Modal
        centered
        open={viewPanPhoto}
        onOk={(e) => setViewPanPhoto(!viewPanPhoto)}
        onCancel={(e) => setViewPanPhoto(!viewPanPhoto)}
        width={800}
        title="PAN Comparison"
        footer={null}
      >
        <div>
          <h6 className="mt-3">FILLED BY CANDIDATE</h6>
          <div
            className={`verify__photo ${
              candidateDetails?.candidatePhoto?.length !== 0
                ? ""
                : "verify__photo_active"
            }`}
          >
            {candidateDetails?.candidatePhoto?.length !== 0 ? (
              // <img
              //   src={url(imageLink)}
              //   style={{ width: "100%", height: "100%" }}
              //   alt="Avatar"
              // />
              candidateDetails?.candidatePhoto && (
                <img
                  alt="passport_photo"
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "contain",
                  }}
                  src={s3Files?.candidatePhoto}
                />
              )
            ) : (
              <img
                src="https://mdbcdn.b-cdn.net/img/new/avatars/2.webp"
                style={{ width: "100%", height: "100%" }}
                alt="passport_photo"
              />
            )}
          </div>
          <div className="d-flex mt-2" style={{ gap: "1rem" }}>
            <div>
              Name : <strong>{candidateDetails?.name}</strong>
            </div>
            <div>
              DOB :{" "}
              <strong>
                {formatDateDDMMYYYY(new Date(candidateDetails?.DOB))}
              </strong>
            </div>
            <div>
              PAN No. :{" "}
              <strong>
                {candidateDetails?.panCardNo === ""
                  ? "Not filled"
                  : candidateDetails?.panCardNo}
              </strong>
            </div>
          </div>
          <h6 className="mt-3">PAN Image</h6>
          <div
            style={{
              width: "100%",
              height: "500px",
              overflowY: "auto",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {candidateDetails?.panCardImage.length !== 0 ? (
              <>
                {/* {candidateDetails?.panCardImage && (
                              <img
                                style={{objectFit:'contain' }}
                                src={
                                  documentType === "S3" && BASE.storageType
                                    ? s3Files.panCardImage
                                    : url("/uploads/") +
                                      candidateDetails?.panCardImage[0]?.filename
                                }
                                alt="pancard"
                              />
                            )} */}
                <Image src={panImage} />
              </>
            ) : (
              <>
                <h3>Image not uploaded yet.</h3>
              </>
            )}
          </div>
        </div>
      </Modal>

      <RejectModal
        open={panImgReject}
        closeHandler={setPanImgReject}
        value={imgPanRejectReason}
        setValue={setImgPanRejectReason}
        onSubmit={() => acceptRejectPanImage(false, imgPanRejectReason)}
      />

      <RejectModal
        open={panRejectModal}
        closeHandler={setPanRejectModal}
        value={panRejectReason}
        setValue={setPanRejectReason}
        onSubmit={() =>
          candidateDetails?.panNoType === "pan_number"
            ? acceptRejectPan(panDetails._id, false)
            : acceptRejectAcknowledgementNumber(candidateDetails?._id, false)
        }
      />
    </>
  );
};

export default PanCardSection;
